<template>
  <div class="app-promo-footer-desktop" v-if="!dismissed">
    <button class="app-promo-footer__close" @click="close" aria-label="Cerrar">×</button>

    <div class="app-promo-footer__logo">
      <img :src="cLogoPath" alt="HelloBB" />
    </div>

    <div class="app-promo-footer__content">
      <div class="app-promo-footer__title">{{ cTitle }}</div>
      <div class="app-promo-footer__text">{{ cSubtitle }}</div>
    </div>

    <button @click="onCta" class="app-promo-footer__cta">{{ cCtaText }}</button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const DEFAULT_STORAGE_KEY = "appPromoFooterDesktopDismissedAt";

export default {
  name: "AppPromoFooterDesktop",
  props: {
    title: String,
    subtitle: String,
    ctaText: String,
    ctaAction: Function,
    reappearAfterHours: { type: Number, default: 0 },
    logoPath: String,
    notShowForTypes: { type: Array, default: () => [] },
    storageKey: { type: String, default: DEFAULT_STORAGE_KEY }, // opcional, por si quieres campañas distintas
  },
  data() {
    return { dismissed: true };
  },
  computed: {
    ...mapGetters({ user: "user" }),
    cTitle() { return this.title ?? this.$t("apppromo.title"); },
    cSubtitle() { return this.subtitle ?? this.$t("apppromo.subtitle"); },
    cCtaText() { return this.ctaText ?? this.$t("home2.cta"); },
    cLogoPath() { return this.logoPath?.trim() || "/favicon/apple-icon-57x57.png"; },
  },
  mounted() {
    this.checkShouldShow();
  },
  methods: {
    onCta() {
      window.mixpanel?.track("Click App Promo Footer", { location: "desktop" });
      if (typeof this.ctaAction === "function") {
        this.ctaAction();
      } else {
        window.open("/signup?utm_source=guest-list-desktop", "_blank");
      }
      this.$emit("cta-click");
    },
    close() {
      window.mixpanel?.track("Close App Promo Footer", { location: "desktop" });
      this.dismissed = true;
      try { localStorage.setItem(this.storageKey, Date.now().toString()); } catch {}
    },
    checkShouldShow() {
      // No mostrar por tipos de lista
      const blocked = this.user?.lists?.some(l => this.notShowForTypes.includes(l.type));
      if (blocked) { this.dismissed = true; return; }

      // Reaparición según horas desde cierre
      try {
        const ts = localStorage.getItem(this.storageKey);
        if (!ts) { this.dismissed = false; return; }
        const closedAt = parseInt(ts, 10);
        if (Number.isNaN(closedAt)) { localStorage.removeItem(this.storageKey); this.dismissed = false; return; }
        const diffHours = (Date.now() - closedAt) / (1000 * 60 * 60);
        this.dismissed = diffHours < this.reappearAfterHours;
      } catch {
        this.dismissed = false; // si falla storage, mostrar
      }
    },
  },
};
</script>

<style scoped>
.app-promo-footer-desktop {
  position: fixed;
  bottom: 0; left: 0; right: 0;
  background: #1e0028; color: white;
  display: flex; align-items: center; justify-content: flex-start;
  padding: 16px 24px; gap: 16px; z-index: 900;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.1);
}
.app-promo-footer__close {
  background: none; border: none; font-size: 20px; cursor: pointer; color: white; margin-right: 8px; flex-shrink: 0;
}
.app-promo-footer__logo img {
  width: 44px; height: 44px; border-radius: 12px; background: white; padding: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);
}
.app-promo-footer__content { flex: 1; display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.app-promo-footer__title { font-weight: 600; font-size: 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.app-promo-footer__text { font-size: 14px; color: white; }
.app-promo-footer__cta {
  background: #ffc944; color: #1e0028; font-weight: bold; padding: 10px 16px; border-radius: 50px;
  text-decoration: none; white-space: nowrap; flex-shrink: 0; margin-left: auto;
}
@media (max-width: 768px) {
  .app-promo-footer-desktop { display: none; }
}
</style>
